// @flow
import type {Node} from 'react'
import React, {Component} from 'react'
import classNames from 'classnames'
import Modal from 'components/ui/Modal'

import type {
  ActionFunction,
  AsyncActionFunction,
} from 'components/types'
import Body from './Body'
import Footer from './Footer'

type Props = {
  children: Node,
  className: string,
  delete: ?AsyncActionFunction,
  disableSave: boolean,
  extraButton: ?(Node) => Node,
  id: ?string,
  isOpen: boolean,
  keyboard: boolean,
  leftBlock: ?() => Node,
  onOpened?: ActionFunction,
  onSubmit?: Object => void,
  save: ?AsyncActionFunction,
  saveTitle: string,
  size: string,
  title: string | Node,
  tooltip: string | null,
  cite: string | null,
  toggle: ActionFunction,
  explanation: ?Node,
}

class NewEditModal extends Component<Props> {
  static defaultProps: {
  cite: null,
  className: string,
  delete: null,
  disableSave: boolean,
  explanation: null,
  extraButton: null,
  id: null,
  keyboard: boolean,
  leftBlock: null,
  save: null,
  saveTitle: string,
  size: string,
  tooltip: null,
} = {
      className: '',
      delete: null,
      disableSave: false,
      extraButton: null,
      id: null,
      keyboard: true,
      leftBlock: null,
      save: null,
      saveTitle: '',
      size: '',
      explanation: null,
      tooltip: null,
      cite: null,
    }

  get className(): string {
    return classNames('edit-dialog-modal', this.props.className)
  }

  render(): null | Node {
    if (!this.props.isOpen)
      return null

    return (
      <Modal
        autofocus={false}
        test-id={this.props.id}
        closeOnEscape={this.props.keyboard}
        onOpened={this.props.onOpened}
        size={this.props.size}
        close={this.props.toggle}
      >
        <Modal.Header
          close={this.props.toggle}
          title={this.props.title}
          tooltip={this.props.tooltip}
          cite={this.props.cite}
        />
        {this.props.explanation}
        <Body>
          {this.props.children}
        </Body>
        <Footer
          delete={this.props.delete}
          disableSave={this.props.disableSave}
          extraButton={this.props.extraButton}
          leftBlock={this.props.leftBlock}
          onSubmit={this.props.onSubmit || this.props.toggle}
          save={this.props.save}
          saveTitle={this.props.saveTitle}
        />
      </Modal>
    )
  }
}

export default NewEditModal
